<form class="app-form" [formRoot]="form">
  <div class="setup-content" id="step-1">
    <h4>{{ 'MESSAGES.INFOS.ONE_LAST_STEP' | translate }}</h4>
    <p class="mb-1">{{ 'MESSAGES.INFOS.PLEASE_PROVIDE_THE_FOLLOWING_INFORMATION' | translate }}</p>
    <div class="form-group">
      <label for="companyName" class="col-form-label label-required">{{ 'LABELS.BUSINESS_NAME' | translate }}</label>
      <input
        class="form-control"
        type="text"
        [formField]="form.companyName"
        id="companyName"
        autocomplete="organization"
        placeholder="{{ 'MESSAGES.PROMPTS.ENTER_BUSINESS_NAME' | translate }}"
        appFormFieldOnError
        [customMessages]="{
          required: 'MESSAGES.ERRORS.BUSINESS_NAME_REQUIRED' | translate,
          pattern: 'MESSAGES.ERRORS.BUSINESS_NAME_INVALID' | translate,
          notUnique: 'MESSAGES.ERRORS.COMPANY_NAME_ALREADY_TAKEN' | translate
        }"
      />
    </div>
    <div class="form-group">
      <label for="country" class="col-form-label label-required">{{ 'LABELS.COUNTRY' | translate }}</label>
      <ng-select
        [items]="countryList"
        id="country"
        [formField]="form.country"
        bindLabel="Name"
        bindValue="Name"
        class="form-control-inverse btn-square ng-select-outline"
      >
      </ng-select>
    </div>

    <div class="form-group mb-0 mt-6">
      <div class="custom-control custom-checkbox">
        <input id="confirm" type="checkbox" [formField]="form.confirm" class="custom-control-input" />
        <label class="custom-control-label text-muted" for="confirm">
          {{ 'MESSAGES.PROMPTS.READ_AND_ACCEPT_TERMS' | translate }}<a
            class="ml-1"
            [href]="termsAndConditionsUrl"
            target="_blank"
            >{{ 'LABELS.TERMS' | translate }}
          </a>
          <span [textContent]="'LABELS.AND' | translate"></span>
          <a class="ml-1" href="https://www.halodot.io/legal/eula" target="_blank">EULA&nbsp;</a>
        </label>
      </div>
    </div>
    <button class="btn btn-gradient btn-block mt-4" type="submit" [disabled]="form().invalid() || form().submitting()">
      {{ 'LABELS.CONTINUE' | translate }}
    </button>
  </div>
</form>
